import React from 'react';
import Navigation from '../components/Navigation';
import SEO from '../components/SEO';

function About() {
  return (
    <div className="min-h-screen bg-gray-50">
      <SEO
        title="About Us - FreeDisposableEmail.com | Free Temporary Email Service"
        description="Learn about FreeDisposableEmail.com - your trusted source for temporary email addresses. Discover our mission, features, and how we help protect your online privacy."
        keywords="about temporary email, disposable email service, email privacy, temporary email provider, free email service"
      />
      <Navigation />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-lg shadow-md p-8 md:p-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-6">About FreeDisposableEmail.com</h1>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-700 mb-6 text-lg">
              Welcome to <strong>FreeDisposableEmail.com</strong>, your trusted source for temporary email addresses. 
              We provide a fast, secure, and completely free disposable email service to help you protect your privacy online.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Our Mission</h2>
            <p className="text-gray-700 mb-6">
              Our mission is to provide a simple, reliable, and privacy-focused temporary email service that helps 
              users protect their personal information from spam, unwanted marketing emails, and potential data breaches. 
              We believe everyone has the right to online privacy and should have easy access to tools that protect it.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Why Use Disposable Email?</h2>
            <ul className="list-disc list-inside text-gray-700 mb-6 space-y-2">
              <li><strong>Protect Your Privacy:</strong> Keep your real email address private and avoid spam</li>
              <li><strong>Quick Sign-ups:</strong> Use temporary emails for one-time registrations and verifications</li>
              <li><strong>No Registration Required:</strong> Get instant access without creating an account</li>
              <li><strong>Auto-Expiry:</strong> Emails automatically expire after 30 minutes for added security</li>
              <li><strong>Real-Time Updates:</strong> Receive emails instantly with our WebSocket technology</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">How It Works</h2>
            <ol className="list-decimal list-inside text-gray-700 mb-6 space-y-3">
              <li><strong>Generate:</strong> Click the button to instantly create a temporary email address</li>
              <li><strong>Use:</strong> Use this email address for any website registration or verification</li>
              <li><strong>Receive:</strong> All emails sent to your temporary address appear in your inbox in real-time</li>
              <li><strong>Auto-Delete:</strong> Your inbox and all emails automatically expire after 30 minutes</li>
            </ol>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Our Features</h2>
            <div className="grid md:grid-cols-2 gap-6 mb-6">
              <div className="bg-blue-50 p-6 rounded-lg">
                <h3 className="font-semibold text-lg text-gray-900 mb-2">⚡ Instant Generation</h3>
                <p className="text-gray-700">Get a temporary email address in seconds, no waiting required.</p>
              </div>
              <div className="bg-green-50 p-6 rounded-lg">
                <h3 className="font-semibold text-lg text-gray-900 mb-2">🔒 Privacy First</h3>
                <p className="text-gray-700">No registration, no tracking, complete anonymity.</p>
              </div>
              <div className="bg-purple-50 p-6 rounded-lg">
                <h3 className="font-semibold text-lg text-gray-900 mb-2">📧 Real-Time Inbox</h3>
                <p className="text-gray-700">Receive emails instantly with live updates.</p>
              </div>
              <div className="bg-yellow-50 p-6 rounded-lg">
                <h3 className="font-semibold text-lg text-gray-900 mb-2">🛡️ Auto-Expiry</h3>
                <p className="text-gray-700">Emails automatically delete after 30 minutes for security.</p>
              </div>
            </div>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Technology</h2>
            <p className="text-gray-700 mb-6">
              FreeDisposableEmail.com is built with modern web technologies including React, Node.js, MongoDB, 
              and Socket.IO to provide a fast, reliable, and secure experience. We use industry-standard 
              security practices to ensure your data is protected.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Contact Us</h2>
            <p className="text-gray-700 mb-6">
              Have questions or feedback? We'd love to hear from you! Visit our <a href="/contact" className="text-primary-600 hover:underline">Contact page</a> 
              or check out our <a href="/faq" className="text-primary-600 hover:underline">FAQ</a> for common questions.
            </p>

            <div className="mt-8 pt-6 border-t border-gray-200">
              <p className="text-sm text-gray-500">
                Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
